// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tk1ms7MWohWYDm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(100% - 72px);
  height: 36px;
  margin: var(--ds-space-0, 0) auto;
  overflow: hidden;
}
.tk1ms7MWohWYDm::before {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  border-radius: 1px;
  background-color: var(--ds-border, #091e4224);
}
.tk1ms7MWohWYDm:focus {
  outline: none;
}
`, ""]);
// Exports
export var separatorCardFront = `tk1ms7MWohWYDm`;
export default ___CSS_LOADER_EXPORT___;
